module.exports = __webpack_public_path__ + "fonts/sk_icons.2a71ea3.eot";